import http from './http-service'
import config from '../config/constant'
import { store } from '../store'

const getBeneficiaryList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'REGISTUSER',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.corpBeneList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getSalaryUploadList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'FILEUPLOADGETRECORDS',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.fileUpload.getRecords, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}
const getInvalidUploadList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.salaryDownloadatinitlevel, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const getFundTransferList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'REGISTUSER',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.fundTransferList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getBillPaymentList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'REGISTUSER',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.getBillPaymentRequestList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getTDList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      listType:"PENDING",
      bulkFlag: '',
      module:"TERMDEPOSIT",
      requestId: 'GETTDREQUETLIST',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.getTDList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getCheckbookRequestList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'REGISTUSER',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.chequeBookRequestList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getStopCheckbookList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'REGISTUSER',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.stopChequePaymentList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getSIList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'REGISTUSER',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.siGetRecords, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const beneficiaryVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.beneficiaryVerifyAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const beneficiaryConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.beneficiaryConfirmAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const beneficiaryDeleteRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.approvals.beneficiaryDeleteRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const stopChequeVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.stopChequePaymentVerifyAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const stopChequeConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.stopChequePaymentAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const stopChequeDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.approvals.stopChequeDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const chequeBookVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.chequeBookVerifyAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const chequeBookConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.chequeBookAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const chequeBookDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.approvals.chequeBookDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const SIVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.siVerifyAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const SIConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.siCreateAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const SIDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.approvals.siDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}



const FTVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.transferVerifyAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const FTConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.transferAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const FTDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.approvals.transferDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const paymentVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'BILLPAYVERIFY',
    }
    const response = await http.post(config.approvals.billPaymentVerifyAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const depositVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId:  "AUTHORIZETDREQUEST",
      module: "TERMDEPOSIT",
    }
    const response = await http.post(config.approvals.TDVerifyAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const paymentConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'BILLPAYVERIFYCONFIRM',
    }
    const response = await http.post(config.approvals.billPayAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const depositConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId:  "AUTHORIZETDREQUEST",
      module: "TERMDEPOSIT",
    }
    const response = await http.post(config.approvals.TDAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const paymentDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.approvals.billPayDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}



const salaryUploadVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.salaryUploadAuthVerifyRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const salaryUploadConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.approvals.salaryUploadAuthRequest, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const salaryUploadDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.approvals.salaryUploadDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const getFtAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.comments.fundTransfer, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getPaymentAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.comments.payment, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getSiAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.comments.si, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getCheckBookAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.comments.checkbook, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getStopChequeAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.comments.stopCheque, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getSalaryUploadAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.comments.salaryUpload, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getBeneficiaryAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.comments.beneficiary, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getTDAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.comments.termDeposite, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export function showFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/pdf' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.pdf`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

export function showXlsxFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/xlsx' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

export function showXlsFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/xlsx' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.xls`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}



const chequeBookDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DOWNLOADREC",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.cbPendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}


const stopChequeDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DOWNLOADREC",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.scPendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}

const SIDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DOWNLOADREC",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.siPendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}


const salaryUploadDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DOWNLOADREC",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.suPendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}



const cardLessCashDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DOWNLOADREC",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.cbPendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}

const salaryDownloadatinitlevelexcel = async (data,fileName) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "REGISTUSER",
      file:fileName
    }
    console.log(reqParams)
    const response = await http.post(config.userActions.salaryDownloadatinitlevelexcel, reqParams, { responseType: "blob" })
    showXlsFile(response.data, fileName)
  } catch (err) {
    return Promise.reject(err)
  }
}

const salaryUploadDownloadView = async (data,fileName) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "REGISTUSER",
    }
    console.log(reqParams)
    const response = await http.post(config.userActions.downloadSalaryUploadFile, reqParams, { responseType: "blob" })
    showXlsxFile(response.data, fileName)
  } catch (err) {
    return Promise.reject(err)
  }
}


const billPaymentDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DOWNLOADREC",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.billPendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}


const beneficiaryDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DOWNLOADREC",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.BenePendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}


const ftDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DOWNLOADREC",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.ftPendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}

const tdDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.approvals.tdDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}



const getCardLessCashList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      // bulkFlag: '',
      requestId: 'CARDLESSLIST',
      userType: userDetails?.userType,
      module: 'CARDLESSCASHOUT',

    }
    const response = await http.post(config.cardLessCash.getRecords, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}



const cardLessCashVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'INITIATECARDLESSCASHOUT',
    }
    const response = await http.post(config.cardLessCash.authVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const cardLessCashConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      beneType:'',
      requestId: 'APPOVECARDLESSCASHOUT',
    }
    const response = await http.post(config.cardLessCash.authConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const cardLessCashDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEINITRECORD"
    }
    const response = await http.post(config.cardLessCash.delete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}


const getCardLessCashAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.cardLessCash.getTrackRecords, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getDebitCardList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'DEBITCARDREQUEST',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.debitCardGetRecords, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const debitCardDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST"
    }
    const response = await http.post(config.approvals.debitCardDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const debitCardVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'DEBITCARDREQUEST',
    }
    const response = await http.post(config.approvals.debitCardAuthVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const debitCardConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'DEBITCARDREQUEST',
    }
    const response = await http.post(config.approvals.debitCardAuthConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getDebitCardAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST"
    }
    const response = await http.post(config.comments.debitCard, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const debitCardDownload = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.dbPendingDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}

const getBlockCardList = async (data) => {
  try {
    const { app } = store.getState()
    const { userDetails } = app

    const reqParams = {
      ...data,
      bulkFlag: '',
      requestId: 'BLOCKDEBITCARD',
      userType: userDetails?.userType,
    }
    const response = await http.post(config.approvals.blockCardGetRecords, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const blockCardDelete = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "BLOCKDEBITCARD"
    }
    const response = await http.post(config.approvals.blockCardDelete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const blockCardVerifyAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'BLOCKDEBITCARD',
    }
    const response = await http.post(config.approvals.blockCardAuthVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const blockCardConfirmAuthRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'BLOCKDEBITCARD',
    }
    const response = await http.post(config.approvals.blockCardAuthConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getBlockCardAuthComments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "BLOCKDEBITCARD"
    }
    const response = await http.post(config.comments.blockCard, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const blockCardDownload = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "BLOCKDEBITCARD",
      bulkFlag: "",
      ftType: "",
      userType: "C"
    }
    console.log(reqParams)
    const response = await http.post(config.approvals.blockCardDownload, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Records_${new Date().getTime()}`)
  } catch (err) {
    return Promise.reject(err)
  }
}



const ApprovalService = {
  getBeneficiaryList,
  getSalaryUploadList,
  getFundTransferList,
  getBillPaymentList,
  getCheckbookRequestList,
  getStopCheckbookList,
  getSIList,
  beneficiaryVerifyAuthRequest,
  beneficiaryConfirmAuthRequest,
  beneficiaryDeleteRequest,
  stopChequeVerifyAuthRequest,
  stopChequeConfirmAuthRequest,
  chequeBookVerifyAuthRequest,
  chequeBookConfirmAuthRequest,
  chequeBookDelete,
  stopChequeDelete,
  SIVerifyAuthRequest,
  SIConfirmAuthRequest,
  SIDelete,
  FTDelete,
  FTConfirmAuthRequest,
  FTVerifyAuthRequest,
  paymentDelete,
  paymentConfirmAuthRequest,
  paymentVerifyAuthRequest,
  salaryUploadVerifyAuthRequest,
  salaryUploadConfirmAuthRequest,
  salaryUploadDelete,
  chequeBookDownload,
  ftDownload,
  beneficiaryDownload,
	billPaymentDownload,
	salaryUploadDownload,
	SIDownload,
	stopChequeDownload,
  getFtAuthComments,
  getPaymentAuthComments,
  getSiAuthComments,
  getCheckBookAuthComments,
  getStopChequeAuthComments,
  getSalaryUploadAuthComments,
  getBeneficiaryAuthComments,
  salaryUploadDownloadView,
  getInvalidUploadList,
  salaryDownloadatinitlevelexcel,
  getTDList,
  depositVerifyAuthRequest,
  depositConfirmAuthRequest,
  tdDelete,
  getCardLessCashList,
  cardLessCashVerifyAuthRequest,
  cardLessCashConfirmAuthRequest,
  cardLessCashDelete,
  cardLessCashDownload,
  getCardLessCashAuthComments,
  getTDAuthComments,
  getDebitCardList,
  debitCardDelete,
  debitCardVerifyAuthRequest,
  debitCardConfirmAuthRequest,
  getDebitCardAuthComments,
  debitCardDownload,
  getBlockCardList,
  blockCardDelete,
  blockCardVerifyAuthRequest,
  blockCardConfirmAuthRequest,
  getBlockCardAuthComments,
  blockCardDownload,
}

export default ApprovalService
